import { render, staticRenderFns } from "./MasterCompanyInstruction.vue?vue&type=template&id=88a27bee&scoped=true&"
import script from "./MasterCompanyInstruction.vue?vue&type=script&lang=js&"
export * from "./MasterCompanyInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a27bee",
  null
  
)

export default component.exports